// extracted by mini-css-extract-plugin
export default {"notImplemented":"dynamic-field_notImplemented__OebkP"};